<template>
  <div class="attitude_detail">
    <!-- <div class="title">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>态度考核</b>
      <div class="btn student_btn">
        <el-select
          v-model="userId"
          placeholder="请选择学生"
          size="mini"
          @change="getInfo"
        >
          <el-option label="全班" :value="null"></el-option>
          <el-option
            v-for="item in studentList"
            :key="item.userId"
            :label="item.name"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="btn chapter_btn">
        <el-cascader
          v-model="classChapterId"
          @change="getInfo"
          :options="chapters"
          :props="{
            label: 'title',
            value: 'classChapterId',
            emitPath: false,
          }"
          :show-all-levels="false"
          size="mini"
          placeholder="请选择章节"
        ></el-cascader>
      </div>
    </div>
    <div class="main">
      <div class="box" v-for="(item, idx) in list" :key="idx">
        <p class="box_title">{{ item.title }}</p>
        <p class="content">{{ item.num }}</p>
        <div class="line_box left_top"></div>
        <div class="line_box right_top"></div>
        <div class="line_box right_bottom"></div>
        <div class="line_box left_bottom"></div>
      </div>
    </div> -->

    <div class="top-row">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>态度成绩</b>
    </div>

    <main>
      <el-cascader
        v-model="classChapterId"
        @change="getInfo"
        :options="chapters"
        :props="{
          label: 'title',
          value: 'classChapterId',
          emitPath: false,
        }"
        :show-all-levels="false"
        size="mini"
        placeholder="请选择章节"
      ></el-cascader>

      <div class="list">
        <table
          width="100%"
          border="1"
          cellspacing="0"
          cellpadding="15"
          align="center"
        >
          <tr v-for="(item, idx) in list" :key="idx" style="text-align: center">
            <td width="10%">{{ idx + 1 }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.num }}</td>
          </tr>
        </table>
        <!-- <div class="box" v-for="(item, idx) in list" :key="idx">
          <p class="box_title">{{ item.title }}</p>
          <p class="content">{{ item.num }}</p>
        </div> -->
      </div>
    </main>
  </div>
</template>

<script>
import { chapterList } from "@/api/chapter";
import { userTdDetail } from "@/api/evaluation";
import { formatSeconds, handleTree } from "@/utils";

export default {
  name: "attitudeDetail",
  data() {
    return {
      formatSeconds,
      chapters: [],
      classChapterId: Number(this.$route.query.classChapterId),
      userId: Number(this.$route.query.userId),
      list: [
        { title: "作品件数", num: 0 },
        { title: "签到成功次数", num: 0 },
        { title: "投票次数", num: 0 },
        { title: "议论次数", num: 0 },
        { title: "抢答次数", num: 0 },
        { title: "评分次数", num: 0 },
        { title: "练习完成次数", num: 0 },
        { title: "完成互动次数", num: 0 },
        { title: "笔记次数", num: 0 },
        { title: "互动次数", num: 0 },
        { title: "预习次数", num: 0 },
        { title: "预习时长", num: 0 },
        { title: "课件查看次数", num: 0 },
        { title: "课件时长", num: 0 },
      ],
    };
  },
  created() {
    this.getChapterList();
    this.getInfo();
  },
  computed: {
    studentList() {
      return this.$store.state.studentList;
    },
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          let chapters = handleTree(res.data, "chapterId");

          chapters.forEach((item) => {
            if (item.children) {
              // 二级目录
              let secondArr = item.children;
              secondArr.forEach((s) => {
                if (s.children) {
                  // 三级目录为底层
                  let thirdArr = s.children;
                  let flag = thirdArr.every((t) => !t.complete);
                  if (flag) {
                    // 三级目录里全部未生成成绩
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  } else {
                    // 三级目录筛选
                    thirdArr.forEach((t) => {
                      if (!t.complete) {
                        thirdArr = thirdArr.filter(
                          (n) => n.chapterId != t.chapterId
                        );
                      }
                    });
                  }
                } else {
                  // 二级目录为底层
                  if (!s.complete) {
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  }
                }
              });
              // 一级目录的children赋值
              if (secondArr.length > 0) {
                item.children = secondArr;
              } else {
                delete item.children;
              }
            }
          });
          // 筛选掉一级目录中无children的，生成最终目录
          this.chapters = chapters.filter((item) => item.children);
        } else {
          console.log(res.msg);
        }
      });
    },
    getInfo() {
      this.$loading.show();
      userTdDetail({
        classId: this.$route.query.id,
        classChapterId: this.classChapterId,
        userId: this.userId,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list[0].num = res.data.worksActionCount || 0;
          this.list[1].num = res.data.signCount || 0;
          this.list[2].num = res.data.voteCount || 0;
          this.list[3].num = res.data.discussCount || 0;
          this.list[4].num = res.data.answerCount || 0;
          this.list[5].num = res.data.scoreCount || 0;
          this.list[6].num = res.data.quizCount || 0;
          this.list[7].num = res.data.chatCount || 0;
          this.list[8].num = res.data.notesCount || 0;
          this.list[9].num = res.data.worksCount || 0;
          this.list[10].num = res.data.videoCount;
          this.list[11].num = this.formatSeconds(res.data.videoDuration);
          this.list[12].num = res.data.pptCount;
          this.list[13].num = this.formatSeconds(res.data.pptDuration);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.attitude_detail {
  // height: 700px;
  // background-image: url("../../../../assets/images/evaluation_bg.png");
  // background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../../assets/images/title_bg1.png");
    background-size: cover;
    .back-btn {
      position: absolute;
      left: 20px;
      top: 13px;
    }
    b {
      letter-spacing: 5px;
      font-size: 30px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .btn {
      position: absolute;
      top: 62px;
      width: 114px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background-image: url("../../../../assets/images/btn_bg.png");
      cursor: pointer;
      &.export_btn {
        right: 0;
      }
      &.student_btn {
        left: 0;
        ::v-deep .el-select {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__suffix {
            right: 6px;
          }
        }
      }
      &.chapter_btn {
        left: 126px;
        ::v-deep .el-select,
        ::v-deep .el-cascader {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__suffix {
            right: 6px;
          }
        }
      }
      ::v-deep .el-select,
      ::v-deep .el-cascader {
        .el-input__inner {
          padding-left: 20px;
          font-size: 14px;
          color: #fff;
          background-color: transparent;
          border: none;
        }
        .el-input__suffix {
          right: 10px;
          .el-select__caret {
            color: #fff;
          }
        }
      }
    }
  }
  .main {
    margin: 10px 0;
    text-align: left;
    .box {
      position: relative;
      display: inline-block;
      margin: 10px;
      padding: 16px 30px;
      width: 220px;
      height: 170px;
      color: #fff;
      text-align: center;
      background-color: #00ffff0a;
      vertical-align: top;
      .box_title {
        margin-bottom: 35px;
        font-size: 20px;
        color: #5bfff4;
      }
      .content {
        font-size: 30px;
      }
      .line_box {
        position: absolute;
        width: 35px;
        height: 35px;
        border-width: 4px;
        border-color: rgba(0, 255, 255, 0.15);
        &.left_top {
          left: 0;
          top: 0;
          border-left-style: solid;
          border-top-style: solid;
        }
        &.right_top {
          right: 0;
          top: 0;
          border-right-style: solid;
          border-top-style: solid;
        }
        &.right_bottom {
          right: 0;
          bottom: 0;
          border-right-style: solid;
          border-bottom-style: solid;
        }
        &.left_bottom {
          left: 0;
          bottom: 0;
          border-left-style: solid;
          border-bottom-style: solid;
        }
      }
    }
  }

  .top-row {
    overflow: hidden;
    .back-btn {
      float: left;
    }
    b {
      font-size: 30px;
      color: teal;
    }
  }
  main {
    margin-top: 20px;
    text-align: left;
    .list {
      margin-top: 20px;
      .box {
        display: inline-block;
        width: 270px;
        margin-right: 20px;
        margin-bottom: 20px;
        .box_title {
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          vertical-align: middle;
        }
        .content {
          padding: 20px 0;
          text-align: center;
          font-size: 30px;
          color: teal;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>